module.exports = __webpack_public_path__ + "static/media/dripped-in-fear.246355c.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/ware-2018/dripped-in-fear.mp3
// module id = rTt+
// module chunks = 0